import { forwardRef, memo } from 'react';
import { SvgIcon } from '@material-ui/core';

export const SentenceExpander = memo(
  forwardRef((props, ref) => {
    return (
      <SvgIcon
        {...props}
        ref={ref}
        viewBox="0 0 115 110"
        data-fill-none
      >
        <mask
          id="mask0_1529_12712"
          style={{ maskType: 'alpha' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="115"
          height="110"
        >
          <rect
            width="115"
            height="110"
            rx="8"
            fill="#D9D9D9"
          />
        </mask>
        <g mask="url(#mask0_1529_12712)">
          <rect
            x="-39.9861"
            y="-2"
            width="197.706"
            height="114"
            rx="6.37762"
            fill="#F4F4F4"
          />
          <rect
            x="9.73551"
            y="33.0956"
            width="38.0104"
            height="18.939"
            rx="2.50313"
            fill="white"
            stroke="#191919"
            strokeWidth="0.927083"
          />
          <path
            d="M45.0806 33.4266L10.0667 50.7895C10.0667 50.7895 10.3126 51.2643 10.7503 51.4357C11.1881 51.6071 11.7818 51.7034 12.4009 51.7034H45.0806C45.6997 51.7034 46.2934 51.6071 46.7312 51.4357C47.1689 51.2643 47.4149 51.0319 47.4149 50.7895V34.3404C47.4149 34.098 47.1689 33.8656 46.7312 33.6942C46.2934 33.5229 45.0806 33.4266 45.0806 33.4266Z"
            fill="#E3E3E3"
          />
          <path
            d="M17.9072 40.4724H32.6839"
            stroke="#191919"
            strokeWidth="1.1125"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M17.9072 44.9226H36.9057"
            stroke="#191919"
            strokeWidth="1.1125"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <rect
            x="9.82822"
            y="33.1883"
            width="37.825"
            height="18.7536"
            rx="2.41042"
            stroke="#191919"
            strokeWidth="1.1125"
          />
          <g clipPath="url(#clip0_1529_12712)">
            <path
              d="M52.7534 63.8894L56.2198 67.3517L52.7534 70.8139"
              stroke="#1E1E1E"
              strokeWidth="0.927083"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M56.2198 67.3518C49.677 67.3518 40.7316 67.8079 39.5811 58.9794"
              stroke="#1E1E1E"
              strokeWidth="0.927083"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <rect
            x="67.8327"
            y="33.0956"
            width="38.0104"
            height="51.5193"
            rx="2.71503"
            fill="white"
            stroke="#191919"
            strokeWidth="0.927083"
          />
          <path
            d="M103.178 33.4263L68.1638 81.7406C68.1638 81.7406 68.4097 83.0618 68.8475 83.5387C69.2853 84.0156 69.879 84.2835 70.4981 84.2835H103.178C103.797 84.2835 104.391 84.0156 104.828 83.5387C105.266 83.0618 105.512 82.415 105.512 81.7406V35.9692C105.512 35.2948 105.266 34.648 104.828 34.1711C104.391 33.6942 103.178 33.4263 103.178 33.4263Z"
            fill="#E3E3E3"
          />
          <path
            d="M76.1104 44.5516H91.9425"
            stroke="#191919"
            strokeWidth="1.19196"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M76.1104 49.3195H96.4659"
            stroke="#191919"
            strokeWidth="1.19196"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M76.1104 54.0873H91.9425"
            stroke="#191919"
            strokeWidth="1.19196"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M76.1104 58.8552H96.4659"
            stroke="#191919"
            strokeWidth="1.19196"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M76.1104 63.6229H96.4659"
            stroke="#191919"
            strokeWidth="1.19196"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M76.1104 68.3907H96.4659"
            stroke="#191919"
            strokeWidth="1.19196"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M76.1104 73.1586H91.9425"
            stroke="#191919"
            strokeWidth="1.19196"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <rect
            x="67.8327"
            y="33.0956"
            width="38.0104"
            height="51.5193"
            rx="2.71503"
            stroke="#191919"
            strokeWidth="0.927083"
          />
          <path
            d="M58.9661 33.6296L57.4794 35.1162L52.5239 30.1607L54.0106 28.674C54.6713 28.0344 55.557 27.6801 56.4766 27.6876C57.3961 27.6951 58.2759 28.0637 58.9262 28.714C59.5764 29.3642 59.9451 30.244 59.9525 31.1636C59.96 32.0832 59.6057 32.9688 58.9661 33.6296Z"
            fill="#FF808C"
          />
          <path
            d="M47.1125 45.483L40.1748 47.4652L42.157 40.5275L47.1125 45.483Z"
            fill="#FFBC44"
          />
          <path
            d="M52.5239 30.1626L42.157 40.5295L47.1125 45.485L57.4794 35.1181L52.5239 30.1626Z"
            fill="#FFEF5E"
          />
          <path
            d="M58.9661 33.6296L57.4794 35.1162L52.5239 30.1607L54.0106 28.674C54.6713 28.0344 55.557 27.6801 56.4766 27.6876C57.3961 27.6951 58.2759 28.0637 58.9262 28.714C59.5764 29.3642 59.9451 30.244 59.9525 31.1636C59.96 32.0832 59.6057 32.9688 58.9661 33.6296Z"
            stroke="#191919"
            strokeWidth="0.927083"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M47.1125 45.483L40.1748 47.4652L42.157 40.5275L47.1125 45.483Z"
            stroke="#191919"
            strokeWidth="0.927083"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M52.5239 30.1626L42.157 40.5295L47.1125 45.485L57.4794 35.1181L52.5239 30.1626Z"
            stroke="#191919"
            strokeWidth="0.927083"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_1529_12712">
            <rect
              width="13.5972"
              height="19.1597"
              fill="white"
              transform="matrix(-4.37114e-08 1 1 4.37114e-08 38.3206 57.972)"
            />
          </clipPath>
        </defs>
      </SvgIcon>
    );
  })
);
